import axios from "axios";

export default {
  namespaced: true,
  state: {
    searches: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    searchesMessage: ''
  },
  mutations: {
    RECEIVED_SEARCHES(state, payload) {
      state.searches = payload;
      state.isReceiving = false;
    },
    RECEIVING_SEARCHES(state) {
      state.isReceiving = true;
    },
    RECEIVED_SEARCH(state, payload) {
      state = Object.assign(state, {
        searches: [...state.searches, payload],
        isReceiving: false,
      })
    },
    RECEIVING_SEARCH(state) {
      state.isReceiving = true;
    },
  },
  actions: {
    async searchCustomerRequest({dispatch}, payload) {
      dispatch("receivingSearches");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/search/customer';
      console.log(payload)
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let response = await axios({method: "POST", url: url, headers: headers, data: payload})
      dispatch("receiveSearches", response.data);
      return response.data
    },
    async searchTenantRequest({dispatch}, payload) {
      dispatch("receivingSearches");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/search/tenant';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let response = await axios({method: "POST", url: url, headers: headers, data: payload})
      dispatch("receiveSearches", response.data);
      return response.data
    },
    async searchVendorRequest({dispatch}, payload) {
      dispatch("receivingSearches");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/search/vendor';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let response = await axios({method: "POST", url: url, headers: headers, data: payload});
      console.log(response);
      dispatch("receiveSearches", response.data);
      return response.data
    },
    receiveSearches({commit}, payload) {
      commit("RECEIVED_SEARCHES", payload)
    },
    receivingSearches({commit}) {
      commit("RECEIVING_SEARCHES")
    },
    receiveSearch({commit}, payload) {
      commit("RECEIVED_SEARCH", payload)
    },
    receivingSearch({commit}) {
      commit("RECEIVING_SEARCH")
    },
  },
};
